import React from "react";

const KeywordIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9009 15.3034L10.7439 17.2317C10.6884 17.3243 10.6099 17.4009 10.5159 17.4541C10.422 17.5072 10.3159 17.5352 10.208 17.5352C10.1001 17.5352 9.99399 17.5072 9.90007 17.4541C9.80615 17.4009 9.7276 17.3243 9.67208 17.2317L8.51507 15.3034C8.45954 15.2109 8.38099 15.1343 8.28708 15.0811C8.19316 15.0279 8.08707 15 7.97914 15H3.33301C3.16725 15 3.00828 14.9341 2.89107 14.8169C2.77386 14.6997 2.70801 14.5407 2.70801 14.375V4.375C2.70801 4.20924 2.77386 4.05027 2.89107 3.93306C3.00828 3.81585 3.16725 3.75 3.33301 3.75H17.083C17.2488 3.75 17.4077 3.81585 17.5249 3.93306C17.6422 4.05027 17.708 4.20924 17.708 4.375V14.375C17.708 14.5408 17.6422 14.6997 17.5249 14.8169C17.4077 14.9342 17.2488 15 17.083 15L12.4369 15C12.329 15 12.2229 15.0279 12.1289 15.0811C12.035 15.1343 11.9565 15.2109 11.9009 15.3034V15.3034Z"
      stroke="#677791"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default KeywordIcon;
